var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"bottom":"","tile":"","color":"red accent-2","width":"100vw"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }